/*
 * @Author: Hyman Choi
 * @Date: 2021-01-14 10:38:15
 * @LastEditTime: 2022-01-25 10:52:25
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \Siui.Cloud.Medical.Web\src\router\Modules\cloudTeaching.js
 */
import Layout from "@/layout";

const cloudTeachingRouter = {
	path: "/cloud_teach_page",
	component: Layout,
	redirect: "/cloud_teach_page/resource_view_page",
	name: "cloudTeaching",
	alwaysShow: true,
	meta: {
		roles: ["超级管理员",'系统管理员'],
		title: "cloudTeaching",
		icon: "cloudTeaching",
	},
	children: [
		{
			path: "resource_view_page",
			name: "resource_view_page",
			component: () => import("@/views/cloudTeaching/resourcePreview/index"),
			meta: {
				roles: ["超级管理员",'系统管理员','Super Admin'],
				title: "resourcePreview",
			},
		},
		{
			path: "previewFiles",
			name: "previewFiles",
			parent:["resource_view_page"],
			component: () =>
				import("@/views/cloudTeaching/resourcePreview/previewFiles/index.vue"),
			meta: {
				roles: ["超级管理员",'系统管理员','Super Admin'],
				title: "previewFiles",
			},
			hidden: true,
		},

	],
};

export default cloudTeachingRouter;
